var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isBlockedBrowser)?_c('div',{staticClass:"browser-mask"},[_vm._m(0)]):_vm._e(),(!_vm.isBlockedBrowser)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('h3',[_vm._v("请使用普通浏览器")])])
}]

export { render, staticRenderFns }